
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import BookingForm from "./BookingForm";

function CalendarTable() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");

  const months = [
    { key: "Jan", label: "January" },
    { key: "Feb", label: "February" },
    { key: "Mar", label: "March" },
    { key: "Apr", label: "April" },
    { key: "May", label: "May" },
    { key: "Jun", label: "June" },
    { key: "Jul", label: "July" },
    { key: "Aug", label: "August" },
    { key: "Sep", label: "September" },
    { key: "Oct", label: "October" },
    { key: "Nov", label: "November" },
    { key: "Dec", label: "December" },
  ];

  // ✅ Helper: Format money with commas
  const formatMoney = (value) => {
    if (!value) return "";

    // Extract numbers and format them
    const num = String(value).replace(/[^0-9]/g, "");
    if (!num) return value;

    const formatted = Number(num).toLocaleString("en-US");

    // Keep UGX or other text if exists
    if (String(value).toUpperCase().includes("UGX")) {
      return `UGX ${formatted}`;
    }

    return formatted;
  };

  const preprocessData = (rawData) => {
    return rawData
      .slice(1)
      .filter((row) => row.__EMPTY)
      .map((row, index) => ({
        SN: index + 1,
        CATEGORY:
          row["UGANDA INSTITUTE OF BANKING AND FINANCIAL SERVICES 2026 Training Cal\nendar "] ||
          "N/A",
        "COURSE/ PROGRAMME": row.__EMPTY || "N/A",
        INVESTMENT: row.__EMPTY_1 || "N/A",
        Jan: row.__EMPTY_2 || "",
        Feb: row.__EMPTY_3 || "",
        Mar: row.__EMPTY_4 || "",
        Apr: row.__EMPTY_5 || "",
        May: row.__EMPTY_6 || "",
        Jun: row.__EMPTY_7 || "",
        Jul: row.__EMPTY_8 || "",
        Aug: row.__EMPTY_9 || "",
        Sep: row.__EMPTY_10 || "",
        Oct: row.__EMPTY_11 || "",
        Nov: row.__EMPTY_12 || "",
        Dec: row.__EMPTY_13 || "",
      }));
  };

  useEffect(() => {
    const fetchExcel = async () => {
      const response = await fetch("/TRAINING CALENDAR 2026- Final.xlsx");
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rawData = XLSX.utils.sheet_to_json(sheet);
      const processed = preprocessData(rawData);
      setData(processed);
      setFilteredData(processed);
    };

    fetchExcel();
  }, []);

  useEffect(() => {
    let temp = [...data];

    if (searchTerm) {
      const lower = searchTerm.toLowerCase();
      temp = temp.filter((item) =>
        Object.values(item).some((v) =>
          String(v || "").toLowerCase().includes(lower)
        )
      );
    }

    if (selectedMonth) {
      temp = temp.filter((course) => course[selectedMonth]);
    }

    setFilteredData(temp);
  }, [searchTerm, selectedMonth, data]);

  return (
    <div>
      {/* Filters */}
      <div className="sm:flex gap-4 items-center mb-4">
        <select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="border rounded px-3 py-1 w-48"
        >
          <option value="">All Months</option>
          {months.map((m) => (
            <option key={m.key} value={m.key}>
              {m.label}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Search course..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border rounded px-3 py-1 w-96"
        />
      </div>

      {/* Table */}
      <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
        <thead className="bg-gray-800 text-white">
          <tr>
            <th className="py-3 px-4">SN</th>
            <th className="py-3 px-4">Category</th>
            <th className="py-3 px-4">Course/Programme</th>
            <th className="py-3 px-4">Investment (UGX)</th>
            <th className="py-3 px-4">Month(s)</th>
            <th className="py-3 px-4">Schedule</th>
            <th className="py-3 px-4">Action</th>
          </tr>
        </thead>

        <tbody>
          {filteredData.map((course, index) => (
            <tr key={index} className="border-b hover:bg-gray-100">
              <td className="py-3 px-4">{course.SN}</td>
              <td className="py-3 px-4">{course.CATEGORY}</td>
              <td className="py-3 px-4">
                {course["COURSE/ PROGRAMME"]}
              </td>

              {/* ✅ Formatted Money */}
              <td className="py-3 px-4 font-semibold">
                {formatMoney(course.INVESTMENT)}
              </td>

              {/* Real Months */}
              <td className="py-3 px-4">
                {selectedMonth
                  ? months.find((m) => m.key === selectedMonth)?.label
                  : months
                      .filter((m) => course[m.key])
                      .map((m) => m.label)
                      .join(", ")}
              </td>

              <td className="py-3 px-4">
                {months
                  .map((m) => course[m.key])
                  .filter(Boolean)
                  .join(", ")}
              </td>

              <td className="py-3 px-4">
                <button
                  className="px-3 py-1 bg-[#a5b595] text-white rounded"
                  onClick={() => setSelectedCourse(course)}
                >
                  Book
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Booking */}
      {selectedCourse && (
        <BookingForm
          course={selectedCourse}
          onClose={() => setSelectedCourse(null)}
        />
      )}
    </div>
  );
}

export default CalendarTable;